const PORT_MIN = 1;
const PORT_MAX = 65535;

/**
 * Returns the input as an integer in [1, 65535], or null for empty,
 * non-numeric, non-integer, or out-of-range values.
 */
export default function sanitizePort(value) {
  if (value === "" || value === null || value === undefined) return null;
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  if (!Number.isInteger(n)) return null;
  if (n < PORT_MIN || n > PORT_MAX) return null;
  return n;
}
